<template>
  <div>
    <section v-if="!isExternalUser" class="complain-tabs">
      <el-radio-group v-model="activeTab" size="medium" class="m-b-sm">
        <el-radio-button v-for="(name, id) in taskTypeMap" :key="+id" :label="+id">{{ name }}维度</el-radio-button>
      </el-radio-group>
    </section>

    <section class="complain-content">
      <complaint-list v-show="activeTab === TASK_TYPE_ENUM.COMPLAINT"></complaint-list>
      <song-list v-show="activeTab === TASK_TYPE_ENUM.SONGLIST"></song-list>
      <match-list v-show="activeTab === TASK_TYPE_ENUM.MATCH"></match-list>
      <confirm-list v-show="activeTab === TASK_TYPE_ENUM.CONFIRM"></confirm-list>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ComplaintList from './components/ComplaintList.vue'
import SongList from './components/SongList/index.vue'
import MatchList from './components/MatchList/index.vue'
import ConfirmList from './components/ConfirmList/index.vue'
import {
  TASK_TYPE_ENUM,
  taskTypeMap
} from './const'

export default {
  name: 'AppealList',
  components: {
    ComplaintList,
    SongList,
    MatchList,
    ConfirmList
  },
  data() {
    return {
      TASK_TYPE_ENUM,
      taskTypeMap,
      activeTab: TASK_TYPE_ENUM.COMPLAINT,
    }
  },
  computed: {
    ...mapGetters([
      'isExternalUser',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.complain-content ::v-deep .el-card__body {
  padding: 10px;
}
</style>
